var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("Progress")]),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress--completed",style:({width: _vm.percent + '%'})})])])}
var staticRenderFns = []

export { render, staticRenderFns }